import React from 'react';
import { testimonials } from '../data/content';
export function Testimonials() {
  return <section className="w-full bg-white px-5 py-16 sm:px-8" data-id="element-262" data-mp="3kpugtgqsmnhi">
      <div className="mx-auto w-full max-w-6xl" data-id="element-263" data-mp="3ksgy483hkhcx">
        <h2 className="text-center text-3xl font-extrabold tracking-tight text-neutral-900 sm:text-4xl" data-id="element-264" data-mp="3fyvx076lj79i">
          What <span className="text-[#6d28d9]" data-id="element-265" data-mp="3azj8zj3znu5c">coaches</span> are saying
        </h2>
        <p className="mt-3 text-center text-sm font-bold text-neutral-800" data-id="element-266" data-mp="36zip3iy4eqqw">
          <span aria-hidden="true" data-id="element-267" data-mp="31zwab52n92fz">⭐⭐⭐⭐⭐</span> 4.9/5 · 500+ coaches worldwide
        </p>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-268" data-mp="3228xpxr6850f">
          {testimonials.map(testimonial => <figure key={testimonial.name} className="rounded-2xl border border-neutral-200 bg-neutral-50 p-6" data-id="element-269" data-mp="2s28cu7dnlgu4">
              <div className="flex items-center gap-3" data-id="element-270" data-mp="v8nbj9lp0ji3">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[#6d28d9] text-xs font-extrabold text-white" data-id="element-271" data-mp="qa3r5dmqzfru">
                  {testimonial.initials}
                </span>
                <span className="text-sm" aria-label="5 out of 5 stars" data-id="element-272" data-mp="m5b2xkhwlmg8">
                  ⭐⭐⭐⭐⭐
                </span>
              </div>
              <blockquote className="mt-4 text-sm font-medium italic leading-relaxed text-neutral-800" data-id="element-273" data-mp="79le7elc2v7t">
                {testimonial.quote}
              </blockquote>
              <figcaption className="mt-6" data-id="element-274" data-mp="zxhaii6zql42">
                <span className="block text-sm font-bold text-neutral-900" data-id="element-275" data-mp="zyscccgvlisj">
                  {testimonial.name}
                </span>
                <span className="block text-xs text-neutral-500" data-id="element-276" data-mp="q7666ujea9wn">
                  {testimonial.location}
                </span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}